import { Logger } from 'alf-ui-js';
import { createContext } from 'react';
import { LOGGER_CONTEXT } from '../appConstants';

export const logger = new Logger(
  {
    syslog: {
      hostName: window.location.hostname,
      appName: LOGGER_CONTEXT.APP_NAME,
    },
    correlation: {
      channel: 'web',
    },
    ULS: {
      applicationCINumber: LOGGER_CONTEXT.APP_CI,
      environmentCINumber: LOGGER_CONTEXT.ENVIRONMENT_CI,
      environment: LOGGER_CONTEXT.ENVIRONMENT,
    },
  },
  {
    remoteURL: `${LOGGER_CONTEXT.BFF_URL}${LOGGER_CONTEXT.LOG_PATH}`,
  },
);

export default createContext(logger);
